module.exports = [{
      plugin: require('/Users/junhanooi/git/forevermark/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-50021802-38"},
    },{
      plugin: require('/Users/junhanooi/git/forevermark/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
